export const CREATE_ACCOUNT_DETAILS_REQUEST = "CREATE_ACCOUNT_DETAILS_REQUEST";
export const CREATE_ACCOUNT_DETAILS_RECEIVE = "CREATE_ACCOUNT_DETAILS_RECEIVE";
export const CREATE_ACCOUNT_DETAILS_FAILURE = "CREATE_ACCOUNT_DETAILS_FAILURE";
export const RESET_CREATE_ACCOUNT_DETAILS = "RESET_CREATE_ACCOUNT_DETAILS";
